import moment from 'moment-timezone';

const StringUtils = {};

StringUtils.truncateText = function(str, length) {
  if (str.length <= length) { return str; }

  var truncated = str.substr(0, length).replace(/[^A-Za-z][A-Za-z]*$/, '...');
  if (truncated.lastIndexOf('...') !== truncated.length - 3) {
    truncated += '...';
  }

  return truncated;
};

StringUtils.trim = function(str) {
  if (!String.prototype.trim) {
    return str.replace(/(^\s+|\s+$)/g, '');
  }

  return str.trim();
};

StringUtils.formatTimestampForEventItem = function (timestamp) {
  return moment(timestamp).calendar(null, {
    sameDay: '[Today at] h:mm A ',
    nextDay: '[Tomorrow at] h:mm A ',
    nextWeek: 'dddd [at] h:mm A ',
    sameElse: 'MMMM D, YYYY [/] h:mm A '
  }) + moment.tz(moment.tz.guess()).zoneAbbr();
};

StringUtils.formatShortDate = function (timestamp) {
  return moment(timestamp).calendar(null, {
    sameDay: '[Today]',
    lastDay: '[Yesterday]',
    sameElse: 'MM[/]DD'
  });
};

StringUtils.formatLongDate = function (timestamp) {
  return moment(timestamp).calendar(null, {
    sameDay:  '[Today]',
    nextDay:  '[Tomorrow]',
    lastDay:  'MMMM D, YYYY',
    nextWeek: 'MMMM D, YYYY',
    lastWeek: 'MMMM D, YYYY',
    sameElse: 'MMMM D, YYYY'
  });
};

StringUtils.formatTime = function (timestamp) {
  return moment(timestamp).calendar(null, {
    sameDay:  'h:mm A ',
    nextDay:  'h:mm A ',
    lastDay:  'h:mm A ',
    nextWeek: 'h:mm A ',
    lastWeek: 'h:mm A ',
    sameElse: 'h:mm A '
  }) + moment.tz(moment.tz.guess()).zoneAbbr();
};

export default StringUtils;
